import { render, staticRenderFns } from "./AssessmentHeader.vue?vue&type=template&id=0e1c053c&"
import script from "./AssessmentHeader.vue?vue&type=script&lang=js&"
export * from "./AssessmentHeader.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AssessmentHeader.vue"
export default component.exports